import React, { useState, useEffect } from 'react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || import.meta.env.REACT_APP_BACKEND_URL;

export const VisitorCounter = () => {
  const [visitorCount, setVisitorCount] = useState(null);

  useEffect(() => {
    // Track visitor when component mounts
    const trackVisitor = async () => {
      try {
        const response = await fetch(`${BACKEND_URL}/api/visitor/track`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' }
        });
        
        if (response.ok) {
          const data = await response.json();
          setVisitorCount(data.total_visitors);
        }
      } catch (error) {
        console.error('Failed to track visitor:', error);
      }
    };

    trackVisitor();
  }, []);

  if (!visitorCount) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: '20px',
      right: '20px',
      backgroundColor: 'rgba(200, 164, 58, 0.95)',
      color: 'white',
      padding: '12px 20px',
      borderRadius: '30px',
      fontSize: '14px',
      fontWeight: 'bold',
      boxShadow: '0 4px 15px rgba(0, 0, 0, 0.3)',
      zIndex: 9999,
      display: 'flex',
      alignItems: 'center',
      gap: '8px'
    }}>
      <span style={{ fontSize: '18px' }}>👁️</span>
      <span>{visitorCount.toLocaleString()} visitors</span>
    </div>
  );
};
